import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import config from 'config';

import { Date, Popup, Content, PhotoSwipeWrapper } from '../components';

@inject('PostStore') @observer
export default class PostDetail extends Component {
	constructor(props) {
    super(props);
    this.openPhotoSwipe = this.openPhotoSwipe.bind(this);
  }

	componentWillMount() {
		const { PostStore } = this.props;
		const { params } = this.props.match;
		PostStore.selectPost(params.slug);
		window.scrollTo(0,0);
	}

	openPhotoSwipe(e, file, title) {
    this.refs.photoSwipeWrapper.openPhotoSwipe(e, file, title);
  }

	render() {
		const { PostStore } = this.props;
		const whatsAppText = () => encodeURI(`${config.app.baseURL}/novidade/${PostStore.post.slug}`);
    return (
			<PhotoSwipeWrapper ref="photoSwipeWrapper">
	      <Popup id="popup-post-detail"
	        title="Novidades"
	        subtitle=""
	        onClose={() => this.props.history.goBack()}
	        titleElement={this.props.titleElement}>
	        <div className="wrapper">
	        { PostStore.post &&
	          <div>
	            { PostStore.post.image_banner && <img className="post-detail-banner" src={PostStore.post.image_banner} alt={PostStore.post.title} /> }

	            <section className="content">
	              <div className="date-share-wrapper">
	                <Date date={PostStore.post.date} />
	              </div>
	              <h1>{PostStore.post.title}</h1>
	              <Content
									content={PostStore.post.content}
									onOpenPhotoSwipe={this.openPhotoSwipe} />
	            </section>
	          </div>
	        }
	        </div>
	      </Popup>
			</PhotoSwipeWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/PostDetail.js